


































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { AclMember } from "@/services/security/types";
import CustomExtensionAccessModal from "@/components/customExtensions/modals/CustomExtensionAccessModal.vue";
import { accessFields } from "@/components/customExtensions/customExtensionFields";

@Component({
    components: { CustomExtensionAccessModal }
})
export default class CustomExtensionAccess extends Vue {
    @Prop() acl!: AclMember[];
    @Prop() collapseState!: boolean;

    // local state
    localCollapseState = true;
    localAcl = [] as AclMember[];
    fields = accessFields;
    searchQuery = ""

    @Watch("acl")
    onPropertyChanged(value: boolean, oldValue: any) {
        this.localAcl = this.acl;
        console.log("this.localAcl");
        console.log(this.localAcl);
    }

    // lifecycle hooks
    mounted() {
        this.localAcl = this.acl;
        this.localCollapseState = this.collapseState;
    }

    // computed
    get filteredData() {
        return this.localAcl && this.localAcl
            .filter(x => this.searchQuery.length === 0 ||
                (x.name.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
                    x.username.toLowerCase().includes(this.searchQuery.toLowerCase())));
    }

    // methods
    promptAddAccess() {
        (this.$refs.accessModal as any).open();
    }

    removeAccess(id: string) {
        const item = this.localAcl.find(x => x.id === id);
        if (!item) {
            return;
        }
        this.localAcl.splice(this.localAcl.indexOf(item), 1);
    }

    onAccessUpdated(data: AclMember[]) {
        this.localAcl = data;
    }

    emitData() {
        // deep copy to avoid binding
        this.$emit("accessUpdated", JSON.parse(JSON.stringify(this.localAcl)));
    }
}
